export default __webpack_public_path__ + "static/apercu-bold-736507f00d3a6446a450cd777e9a79d1.woff";